import { FC, useEffect, useState } from "react";
import { Col, Form, FormGroup, Label, Row } from "reactstrap";
import ModalComponent from "../../shared/base-components/Modal";
import TextField from "../../shared/base-components/TextField";
import { SubmitHandler, useForm } from "react-hook-form";
import Button from "../../shared/base-components/Button";
import { RESPONSE_CODE } from "../../shared/models/Types";
import { successNotify } from "../../shared/utils/notifications";

import { yupResolver } from "@hookform/resolvers/yup";
import Switch from "../../shared/base-components/Switch";
import {
  customerUpdateSchema,
  CustomerUpdateRequest,
  CustomerProfilModalProps,
} from "../Customer/Customer.constants";
import { useCustomerUpdateMutation } from "../Customer/Customer.actions";
import { getItem } from "../../shared/hooks/useCookie";
import { useRecoilValue } from "recoil";
import {
  flutterMessageSelector,
  webViewSelector,
} from "../../shared/actions/LayoutMode.actions";
import { postUserLocation } from "../../shared/internals/asd";

const CustomerModal: FC<CustomerProfilModalProps> = ({
  userData,
  isModalOpen,
  toggle,
  mutate,
}) => {
  const customerProfileId = getItem("customerProfileId");

  const flutterMessage = useRecoilValue(flutterMessageSelector);
  const isWebView = useRecoilValue(webViewSelector);

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<CustomerUpdateRequest>({
    resolver: yupResolver(customerUpdateSchema),
  });

  const {
    data: updateData,
    mutate: customerUpdateMutation,
    isLoading: updateLoading,
  } = useCustomerUpdateMutation();

  const [isActive, setIsActive] = useState<boolean>(true);
  const [isSmsReturnBack, setIsSmsReturnBack] = useState<boolean>(true);

  console.log(userData);

  const onSubmit: SubmitHandler<any> = (
    requestValues: CustomerUpdateRequest
  ) => {
    let lat = "";
    let lng = "";

    if (flutterMessage.startsWith("profilKonum:")) {
      const key = flutterMessage.split(":");

      lat = key[1].split("@")[0];
      lng = key[1].split("@")[1];
    }

    customerUpdateMutation({
      ...requestValues,
      id: userData?.id,
      is_visible: isActive,
      sms_returned_back: isSmsReturnBack,
      lang: lat.length ? lat : undefined,
      long: lng.length ? lng : undefined,
    });
  };

  useEffect(() => {
    if (updateData?.status === RESPONSE_CODE.SUCCESS_CODE) {
      successNotify("Müşteri başarılı bir şekilde güncellendi");

      mutate({ id: customerProfileId });
      toggle();
    }
  }, [updateData]);

  return (
    <ModalComponent
      header={"Müşteri  Güncelle"}
      description={"Müşteri Güncellemek için ilgili alanı düzeltip onaylayın"}
      isOpen={isModalOpen}
      toggle={toggle}
    >
      <Form onSubmit={handleSubmit(onSubmit)} className="custom-form mt-4 pt-2">
        <Row>
          <Col sm="12" md="6" lg="6">
            <FormGroup className="mb-3">
              <Label className="form-label">Müşteri Adı</Label>
              <TextField
                control={control}
                name="fullname"
                defaultValue={userData?.fullname}
                type="text"
                className="form-control"
                placeholder="Yapılacak iş adı"
                error={errors.fullname?.message}
              />
            </FormGroup>
          </Col>

          <Col sm="12" md="6" lg="6">
            <FormGroup className="mb-3">
              <Label className="form-label">Telefon</Label>
              <TextField
                control={control}
                name="phone_number"
                defaultValue={userData?.phone_number}
                type="text"
                className="form-control"
                placeholder="0--- --- -- --"
                error={errors.phone_number?.message}
              />
            </FormGroup>
          </Col>

          <Col sm="12" md="6" lg="6">
            <FormGroup className="mb-3">
              <Label className="form-label">Telefon (2)</Label>
              <TextField
                control={control}
                name="phone_number2"
                defaultValue={userData?.phone_number2}
                type="text"
                className="form-control"
                placeholder="0--- --- -- --"
                error={errors.phone_number2?.message}
              />
            </FormGroup>
          </Col>

          <Col sm="12" md="6" lg="6">
            <FormGroup className="mb-3">
              <Label className="form-label">Telefon (3)</Label>
              <TextField
                control={control}
                name="phone_number3"
                defaultValue={userData?.phone_number3}
                type="text"
                className="form-control"
                placeholder="0--- --- -- --"
                error={errors.phone_number3?.message}
              />
            </FormGroup>
          </Col>

          <Col sm="12" md="6" lg="6">
            <FormGroup className="mb-3">
              <Label className="form-label">İl</Label>
              <TextField
                control={control}
                name="country"
                type="text"
                className="form-control"
                placeholder="İl"
                defaultValue={userData?.country}
                error={errors.country?.message}
              />
            </FormGroup>
          </Col>

          <Col sm="12" md="6" lg="6">
            <FormGroup className="mb-3">
              <Label htmlFor="validationCustom02">İlçe</Label>
              <TextField
                control={control}
                name="district"
                className="form-control"
                type="text"
                placeholder="İlçe"
                defaultValue={userData?.district}
                error={errors.district?.message}
              />
            </FormGroup>
          </Col>

          <Col sm="12" md="6" lg="6">
            <FormGroup className="mb-3">
              <Label className="form-label">Mahalle</Label>
              <TextField
                control={control}
                name="neighbourhood"
                className="form-control"
                type="text"
                placeholder="Mahalle"
                defaultValue={userData?.neighbourhood}
                error={errors.neighbourhood?.message}
              />
            </FormGroup>
          </Col>

          <Col sm="12" md="6" lg="6">
            <FormGroup className="mb-3">
              <Label htmlFor="validationCustom02">Cadde / Sokak</Label>
              <TextField
                control={control}
                name="street"
                className="form-control"
                type="text"
                placeholder="Cadde / Sokak"
                defaultValue={userData?.street}
                error={errors.street?.message}
              />
            </FormGroup>
          </Col>

          <Col sm="12" md="6" lg="6">
            <FormGroup className="mb-3">
              <Label className="form-label">Daire / Numara</Label>
              <TextField
                control={control}
                name="flat_number"
                type="text"
                className="form-control"
                placeholder="Daire / Numara"
                defaultValue={userData?.flat_number}
                error={errors.flat_number?.message}
              />
            </FormGroup>
          </Col>

          <Col sm="12" md="6" lg="6">
            <FormGroup className="mb-3">
              <Label htmlFor="validationCustom02">Kısa Tarif</Label>
              <TextField
                control={control}
                name="address_description"
                className="form-control"
                type="text"
                placeholder="Kısa Tarif"
                defaultValue={userData?.address_description}
                error={errors.address_description?.message}
              />
            </FormGroup>
          </Col>

          <Col sm="12" md="6" lg="6">
            <Label htmlFor="validationCustom02">Durum</Label>

            <FormGroup className="mb-3">
              <Switch
                onChangeHandler={(e: any) => setIsActive(e)}
                name="firstSetup"
                control={control}
                dataOnLabel="Aktif"
                dataOffLabel="Pasif"
                color="success"
                defaultValue={userData?.is_visible}
              />
            </FormGroup>
          </Col>

          <Col sm="12" md="6" lg="6">
            <Label htmlFor="validationCustom02">
              Sms Geri Dönüşü Yapıldı mı ?
            </Label>

            <FormGroup className="mb-3">
              <Switch
                onChangeHandler={(e: any) => setIsSmsReturnBack(e)}
                name="sms_returned_back"
                control={control}
                dataOnLabel="Evet"
                dataOffLabel="Hayır"
                color="success"
                defaultValue={userData?.sms_returned_back}
              />
            </FormGroup>
          </Col>

          {isWebView && (
            <Col sm="12" md="6" lg="6">
              <Label htmlFor="validationCustom02">Konum Güncelle</Label>

              <FormGroup className="mb-3">
                <Button
                  variant="primary"
                  text="Konum Güncelle"
                  onClick={() => postUserLocation(`konumVerKanka`)}
                  type="button"
                ></Button>
              </FormGroup>
            </Col>
          )}

          <Col md="12">
            <FormGroup className="mb-3">
              <Button
                loading={updateLoading}
                text={"Müşteri Güncelle"}
                variant="primary"
              />
            </FormGroup>
          </Col>
        </Row>
      </Form>
    </ModalComponent>
  );
};

export default CustomerModal;
